import Box from '@mui/material/Box';
import { Drawer } from '@mui/material';
import FormDrawerContent from 'components/@home/drawers/FormDrawer/FormDrawerContent';
import Loading from 'components/common/Loading';
import { bool, func, object } from 'prop-types';
import React, { useEffect } from 'react';
import CloseButton from '../CloseButton';

import connector from './connector';
import formik from './formik';

const FormDrawer = ({ form = null, isOpen, isEdit, actions, resetForm }) => {
  useEffect(() => {
    if (isEdit && isOpen && form?._id && !form.loading && !form.loaded) {
      actions.forms.find(form._id);
    }
  }, [isEdit, isOpen, form, actions]);

  const handleClose = () => {
    actions.drawers.form.close();
    resetForm();
  };

  return (
    <Drawer anchor="right" open={isOpen} onClose={handleClose}>
      <Box
        sx={theme => ({
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          width: '100%',
          maxWidth: 'calc(100vw - 40px)',
          [theme.breakpoints.up('md')]: {
            width: 1100,
          },
        })}
      >
        <Box sx={{ pt: '20px', pl: '20px' }}>
          <CloseButton onClick={handleClose} />
        </Box>
        <Box sx={{ display: 'flex', flex: 1 }}>
          {isEdit && form.loading ? <Loading /> : <FormDrawerContent />}
        </Box>
      </Box>
    </Drawer>
  );
};

FormDrawer.propTypes = {
  form: object,
  actions: object.isRequired,
  isOpen: bool.isRequired,
  isEdit: bool.isRequired,
  resetForm: func.isRequired,
};

export default connector(formik(FormDrawer));
